const memoryStorage = {
  setItem: () => {},
  getItem: () => null,
  removeItem: () => {},
  clear: () => {}
};

function createStorage(storage) {
  return {
    set(key, value) {
      try {
        storage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.error(`Storage.set error [${key}]:`, error);
      }
    },

    get(key) {
      try {
        const value = storage.getItem(key);

        if (!value) return null;

        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      } catch (error) {
        console.log(`Storage.get error [${key}]:`, error);
        return null;
      }
    },

    remove(key) {
      storage.removeItem(key);
    },

    clear() {
      storage.clear();
    },

    has(key) {
      return storage.getItem(key) !== null;
    }
  };
}

// Use real storage only in the browser, fallback to memory on server
const isBrowser = typeof window !== "undefined";

export const sessionStore = createStorage(isBrowser ? window.sessionStorage : memoryStorage);

export const localStore = createStorage(isBrowser ? window.localStorage : memoryStorage);
